import { styled } from '@mui/material/styles';
import './NavBarLogo.css';
import { useSelector } from 'react-redux';
import { selectWdNavbar } from 'app/store/core/navbarSlice';
import { selectWdCurrentLayoutConfig } from 'app/store/core/settingsSlice';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeIn,
    }),
  },
  '& > .badge': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

export const NavBarLogo = () => {
  const config = useSelector(selectWdCurrentLayoutConfig);
  const navbar = useSelector(selectWdNavbar);
  const { foldedOpen } = navbar;

  return (
    <Root className="flex items-center">
      {!foldedOpen && config.navbar.style === 'style-2' && (
        <div className="primary-logo-container">
          <img className="primary-logo" src="/assets/images/brands/brand-compact-white-001.svg" alt="logo" />
        </div>
      )}
      <div
        className={`badge flex items-center py-4 rounded
          ${config.navbar.style === 'style-2' ? 'px-8 mx-8' : 'pr-24 mr-24'}
        `}
      >
        <img
          className={`react-badge
            ${config.navbar.style === 'styled-2' ? 'secondary-logo' : 'secondary-logo--style1'}
          `}
          src="/assets/images/brands/brand-extended-white-001.svg"
          alt="logo de biometrics"
        />
      </div>
    </Root>
  );
};
